<template>
  <div class="public-content platform-message">
    <div class="breadcrumb">店铺信息</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="店铺号:">
              <!-- <el-input v-model="formInline.code" placeholder="请输入店铺号"></el-input> -->
              <el-select clearable v-model="formInline.code" :filter-method="filterMethod" filterable placeholder="请输入店铺号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="店铺名称:">
              <el-input v-model="formInline.name" placeholder="请输入店铺姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-input v-model="formInline.salename" placeholder="请输入业务姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="会员状态:">
              <el-select v-model="formInline.status" placeholder="请选择" clearable @clear="formInline.status = null">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否定制:">
              <el-select v-model="formInline.diyApplet" placeholder="请选择" clearable>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable align="left" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item> -->
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, searchPlateform(queryInfo)" round>查询</el-button>
            <!-- <el-button class="search-ok" v-if="$hasPermission('crm:admin:store:export')" v-permission="'crm:admin:store:export'" @click="exportExcel" round>导出Excel</el-button> -->
            <el-button class="search-ok" round type="primary" v-if="$hasPermission('crm:video:season:vip:add')" v-permission="'crm:video:season:vip:add'" @click="applyplatform('OPEN')">
              申请会员</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%" @size-change="sizeChange">
          <el-table-column prop="code" label="店铺号" min-width="10px"></el-table-column>
          <el-table-column prop="shopName" label="店铺名称" min-width="10px"></el-table-column>
          <el-table-column prop="platformType" label="店铺类型" min-width="10">
            <template v-slot="scope">
              <span>{{ scope.row.storeType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="diyApplet" label="是否定制" min-width="10">
            <template v-slot="scope">
              <span>{{ scope.row.diyApplet ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="salesmanName" label="业务" min-width="10"></el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="10">
            <template v-slot="scope">
              <span>{{ $msg.filterBridal(scope.row.phone) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="address" label="地址" min-width="10">
            <template v-slot="scope">
              <span>{{ scope.row.address === undefined ? '' : scope.row.address.completeAddress }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="startTime" label="会员开始日期" width="160"></el-table-column>
          <el-table-column prop="expireTime" label="会员结束日期" width="160"></el-table-column>
          <el-table-column prop="auditStatus" label="套餐类型" min-width="10">
            <template v-slot="scope">
              <span v-html="scope.row.splitImagesOrders[0] ? scope.row.splitImagesOrders[0].name : ''"></span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="会员状态" min-width="10">
            <template v-slot="scope">
              <span v-for="(item, index) in statusList" :key="index">{{ scope.row.status == item.value ? item.label : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productCenter" label="产品中心" min-width="10">
            <template v-slot="scope">
              <el-switch v-model="scope.row.productCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="updateProductCenterData(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="10px" width="200px">
            <template v-slot="scope">
              <span class="color-blue" @click="chack(scope.row)">查看<br></span>
              <span class="color-blue" @click="previewHome(scope.row)">预览装修<br></span>
              <span class="color-blue" @click="setting(scope.row)" v-if="scope.row.diyApplet">配置数据<br></span>
              <span class="color-blue" @click="generateQRCode(scope.row)" v-if="scope.row.wxConfigList.length > 0">二维码<br></span>
              <span class="color-blue" @click="applyplatform('RENEW', scope.row)" v-if="scope.row.status == 1 || scope.row.status == 3">续费<br></span>
              <!-- <span class="color-blue" v-if="scope.row.auditStatus === 'PENDING' && $hasPermission('crm:admin:store:auditStore')" @click="examine(scope.row)" ref="operationRef">审核<br></span>
              <span class="color-blue" v-if="$hasPermission('crm:admin:store:updateStore')" v-permission="'crm:admin:store:updateStore'" @click="edit(scope.row)" ref="operationRef">编辑</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--   分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
    <el-dialog :visible.sync="previewVisible" title="二维码" width="400px" :append-to-body="true" center>
      <div class="qr-preview-container">
        <img :src="qrBase64" class="qr-preview-img" />
      </div>
      <template #footer>
        <!-- <el-button type="primary" round @click="copyQRCode">复制</el-button>
        <el-button type="primary" round @click="downloadQRCode">下载</el-button> -->
      </template>
    </el-dialog>
    <el-dialog :visible.sync="previewHomeVisible" title="预览装修" top="5vh" width="500px" :append-to-body="true" center @close="closePreviewHome">
      <div class="home-decoration-container">
        <div style="
            height: 100vh;
            background-color: #ffffff;
            border: 12px solid #3c3c3c;
            border-radius: 26px;
            overflow-y: auto;
          ">
          <div>
            <!-- 轮播图区域 -->
            <div>
              <div style="display: flex; align-items: center">
                <div style="
                    position: relative;
                    left: 15px;
                    top: 8px;
                    color: black;
                    font-weight: bold;
                    font-size: 16px;
                    z-index: 99;
                  "> 9:41 </div>
                <div></div>
              </div>
              <div style="margin-top: -24px" v-if="homePageParams.bannerVos.length > 0">
                <el-carousel height="260px" class="custom-carousel">
                  <el-carousel-item v-for="(item, index) in homePageParams.bannerVos" :key="index">
                    <img :src="item.bannerUrl" style="width: 100%; height: 100%; object-fit: cover" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div v-else style="
                  width: 100%;
                  height: 260px;
                  border: 1px dashed #3c3c3c;
                  color: black;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: -20px;
                ">
                <div>轮播图区域</div>
              </div>
            </div>
            <!-- 套餐分类区域 -->
            <div>
              <div v-if="classificationData.length > 0">
                <div class="main-container-center-from">
                  <div style="margin-right: 25px" v-for="(item, index) in classificationData" :key="index">
                    <div v-if="item.url" style="width: 68px; height: 53px" class="upload-packageClassification-card" :style="{
                      backgroundImage: `url(${item.url}?x-sds-process=image/resize,l_285,m_mfit)`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                    }"></div>
                    <div style="text-align: center; color: #000; margin-top: 10px; font-size: 13px"> {{ item.name }} </div>
                  </div>
                </div>
              </div>
              <div v-else style="
                  width: 100%;
                  height: 110px;
                  border: 1px dashed #3c3c3c;
                  color: black;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: 10px;
                ">
                <div>套餐分类区域</div>
              </div>
            </div>
            <div>
              <div style="width: 100%" v-if="homePageParams.packageVos.length > 0">
                <!-- 完美瀑布流实现 -->
                <div class="perfect-waterfall">
                  <div v-for="item in waterfallDataComputed" :key="item.id" class="waterfall-item">
                    <div class="image-container">
                      <img :src="item.src" :alt="item.packageName" :title="item.packageName" class="waterfall-image" @load="onImageLoad" @error="handleImageError" loading="lazy" />
                      <!-- 加载状态指示器 -->
                      <div class="loading-indicator" v-if="!item.loaded && !item.error">
                        <i class="el-icon-loading"></i>
                      </div>
                      <!-- 错误状态占位符 -->
                      <div class="error-placeholder" v-if="item.error">
                        <i class="el-icon-picture-outline"></i>
                        <span>图片加载失败</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else style="
                  width: 100%;
                  height: 310px;
                  border: 1px dashed #3c3c3c;
                  color: black;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: 10px;
                ">
                <div>热门套餐区域</div>
              </div>
            </div>
            <!-- 立减券/分享券 展示 -->
            <div v-if="isDiscountTimeAfter(selectedDiscountVos) && isShareTimeAfter(selectedShareVos)" style="
                padding: 0px 10px 0px 10px;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 10px;
              ">
              <div style="
                  width: 100%;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 5px;
                  background: linear-gradient(to right, #fdf0ef, #ffd5d7);
                ">
                <div style="
                    width: 90%;
                    height: 90%;
                    margin: 0 auto;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    -webkit-mask-image:
                      radial-gradient(circle at 50% 10px, transparent 10px, red 10.5px),
                      radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
                    -webkit-mask-size:
                      100%,
                      4px 12px;
                    -webkit-mask-repeat: repeat, repeat-y;
                    -webkit-mask-position:
                      0 -10px,
                      50%;
                    -webkit-mask-composite: source-out;
                    mask-composite: subtract;
                    padding: 20px 4px 20px 4px;
                    background-color: white;
                    border-radius: 10px;
                  ">
                  <div style="display: flex; flex-direction: column; align-items: center">
                    <div style="text-align: center; color: #ed3030; font-size: 16px; font-weight: 400"> 立减券 </div>
                    <div style="text-align: center; color: #ed3030; font-size: 32px"> ￥{{ (selectedDiscountVos && selectedDiscountVos.coupon && selectedDiscountVos.coupon.money) ||
                      (selectedDiscountVos && selectedDiscountVos.money) }} </div>
                  </div>
                  <button style="
                      width: 40%;
                      height: 30px;
                      background-color: #ed3030;
                      color: #fff;
                      border: none;
                      border-radius: 5px;
                      cursor: pointer;
                    "> 立即领取 </button>
                </div>
              </div>
              <div style="
                  width: 100%;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 5px;
                  background: linear-gradient(to right, #fdf0ef, #ffd5d7);
                ">
                <div style="
                    width: 90%;
                    height: 90%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    -webkit-mask-image:
                      radial-gradient(circle at 50% 10px, transparent 10px, red 10.5px),
                      radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
                    -webkit-mask-size:
                      100%,
                      4px 12px;
                    -webkit-mask-repeat: repeat, repeat-y;
                    -webkit-mask-position:
                      0 -10px,
                      50%;
                    -webkit-mask-composite: source-out;
                    mask-composite: subtract;
                    padding: 20px 4px 20px 4px;
                    border-radius: 10px;
                    background-color: white;
                  ">
                  <div style="display: flex; flex-direction: column; align-items: center">
                    <div style="text-align: center; color: #ed3030; font-size: 16px; font-weight: 400"> 分享券 </div>
                    <div style="text-align: center; color: #ed3030; font-size: 32px"> ￥{{ (selectedShareVos && selectedShareVos.shareActivity && selectedShareVos.shareActivity.coupon &&
                      selectedShareVos.shareActivity.coupon.money) || (selectedShareVos && selectedShareVos.coupon && selectedShareVos.coupon.money) }} </div>
                  </div>
                  <button style="
                      width: 40%;
                      height: 30px;
                      background-color: #ed3030;
                      color: #fff;
                      border: none;
                      border-radius: 5px;
                      cursor: pointer;
                    "> 去使用 </button>
                </div>
              </div>
            </div>
            <!-- 只有立减券的时候 -->
            <div style="padding: 10px" v-if="selectedDiscountVos && selectedShareVos === null">
              <div style="
                  width: 100%;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 5px;
                  background: linear-gradient(to right, #fdf0ef, #ffd5d7);
                ">
                <div style="
                    width: 96%;
                    height: 90%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    -webkit-mask-image:
                      radial-gradient(circle at 20% 10px, transparent 10px, red 10.5px),
                      radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
                    -webkit-mask-size:
                      100%,
                      4px 12px;
                    -webkit-mask-repeat: repeat, repeat-y;
                    -webkit-mask-position:
                      0 -10px,
                      20%;
                    -webkit-mask-composite: source-out;
                    mask-composite: subtract;
                    padding: 20px 10px 20px 10px;
                    border-radius: 10px;
                    background-color: white;
                  ">
                  <div style="display: flex; flex-direction: column; align-items: center">
                    <div style="text-align: center; color: #ed3030; font-size: 32px"> ￥{{ (selectedDiscountVos && selectedDiscountVos.coupon && selectedDiscountVos.coupon.money) ||
                      (selectedDiscountVos && selectedDiscountVos.money) }} </div>
                  </div>
                  <div style="
                      flex: 1;
                      display: flex;
                      gap: 10px;
                      align-items: center;
                      justify-content: end;
                    ">
                    <div style="
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        color: #ed3030;
                        font-size: 16px;
                        font-weight: 400;
                      ">
                      <div>店铺优惠</div>
                      <div> 领{{ (selectedDiscountVos && selectedDiscountVos.coupon && selectedDiscountVos.coupon.money) || (selectedDiscountVos && selectedDiscountVos.money) }}元无门槛立减券 </div>
                    </div>
                    <button style="
                        width: 40%;
                        height: 30px;
                        background-color: #ed3030;
                        color: #fff;
                        border: none;
                        border-radius: 5px;
                        cursor: pointer;
                      "> 去使用 </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 只有分享券的时候 -->
            <div style="padding: 10px" v-if="isShareTimeAfter(selectedShareVos) && selectedDiscountVos === null">
              <div style="
                  width: 100%;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 5px;
                  background: linear-gradient(to right, #fdf0ef, #ffd5d7);
                ">
                <div style="
                    width: 96%;
                    height: 90%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    -webkit-mask-image:
                      radial-gradient(circle at 20% 10px, transparent 10px, red 10.5px),
                      radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
                    -webkit-mask-size:
                      100%,
                      4px 12px;
                    -webkit-mask-repeat: repeat, repeat-y;
                    -webkit-mask-position:
                      0 -10px,
                      20%;
                    -webkit-mask-composite: source-out;
                    mask-composite: subtract;
                    padding: 20px 10px 20px 10px;
                    border-radius: 10px;
                    background-color: white;
                  ">
                  <div style="display: flex; flex-direction: column; align-items: center">
                    <div style="text-align: center; color: #ed3030; font-size: 32px"> ￥{{ (selectedShareVos && selectedShareVos.shareActivity && selectedShareVos.shareActivity.coupon &&
                      selectedShareVos.shareActivity.coupon.money) || (selectedShareVos && selectedShareVos.coupon && selectedShareVos.coupon.money) }} </div>
                  </div>
                  <div style="
                      flex: 1;
                      display: flex;
                      gap: 10px;
                      align-items: center;
                      justify-content: end;
                    ">
                    <div style="
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        color: #ed3030;
                        font-size: 16px;
                        font-weight: 400;
                      ">
                      <div>店铺优惠</div>
                      <div> 分享{{ (selectedShareVos && selectedShareVos.shareActivity && selectedShareVos.shareActivity.sharePeopleNum) || (selectedShareVos && selectedShareVos.sharePeopleNum) }}人领取{{
                        (selectedShareVos && selectedShareVos.shareActivity && selectedShareVos.shareActivity.coupon && selectedShareVos.shareActivity.coupon.money) || (selectedShareVos &&
                          selectedShareVos.coupon && selectedShareVos.coupon.money) }}元分享券 </div>
                    </div>
                    <button style="
                        width: 44%;
                        height: 30px;
                        background-color: #ed3030;
                        color: #fff;
                        border: none;
                        border-radius: 5px;
                        cursor: pointer;
                      "> 立即领取 </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 视频展示区域 -->
            <div>
              <div style="width: 95%; padding: 0 10px 0 10px; margin-top: 20px" v-if="homePageParams.videoUrl.length > 0">
                <div style="color: black; font-size: 16px; margin-bottom: 5px">视频展示</div>
                <div style="display: flex; flex-direction: column; gap: 10px">
                  <div v-for="(group, groupIndex) in videoDisplayData" :key="groupIndex" :style="{
                    display: 'flex',
                    gap: '10px',
                    width: '100%',
                  }">
                    <!-- 两个并排显示 -->
                    <template v-if="group.type === 'row'">
                      <div v-for="(video, videoIndex) in group.videos" :key="video.id || videoIndex" style="flex: 1; min-width: 0">
                        <video class="video-element" :src="video.videoUrl" style="width: 100%; height: 200px; border-radius: 5px" controls muted playsinline />
                        <div style="
                            text-align: center;
                            color: black;
                            font-size: 14px;
                            margin-top: 5px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          " :title="video.name"> {{ video.name }} </div>
                      </div>
                    </template>
                    <!-- 单个占满整行 -->
                    <template v-else-if="group.type === 'full'">
                      <div v-for="(video, videoIndex) in group.videos" :key="video.id || videoIndex" style="width: 100%">
                        <video class="video-element" :src="video.videoUrl" style="width: 100%; height: 200px; border-radius: 5px" controls muted playsinline />
                        <div style="
                            text-align: center;
                            color: black;
                            font-size: 14px;
                            margin-top: 5px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          " :title="video.name"> {{ video.name }} </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div v-else style="
                  width: 100%;
                  height: 210px;
                  border: 1px dashed #3c3c3c;
                  color: black;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: 10px;
                ">
                <div>视频展示</div>
              </div>
            </div>
            <!-- 店铺地图和地址信息 -->
            <div style="padding: 10px;">
              <!-- 集成地图，传入省市区的code显示地址 -->
              <div id="map" style="width: 100%; height: 300px; margin-bottom: 10px;"></div>
              <div style="color: black; font-size: 14px;margin-bottom: 10px;"> 电话：{{ currentPreviewRow && currentPreviewRow.address ? currentPreviewRow.address.phone : '' }} </div>
              <div style="color: black; font-size: 14px;margin-bottom: 10px;"> 店铺地址：{{ currentPreviewRow && currentPreviewRow.address ? currentPreviewRow.address.completeAddress : '' }} </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getMembershipList, storeTypeGetStoreTypeList, storeExport, getMembershipListForQuery, qrcodeAddScene, getQRCode, updateProductCenter, getAllProvince, addressGetCityByProvinceCode, addressGetCountyByCityId } from '@/api/crm'
import { getHomeDecoration, getClassificationList } from '@/api/pms'
import moment from 'moment'
export default {
  name: 'platform-message',
  components: {
    VPagination
  },
  data () {
    return {
      diyApplet: '',
      previewVisible: false,
      previewHomeVisible: false,
      qrBase64: '',
      formInline: {
        code: null,
        expireTime: null,
        storeId: null,
        name: null,
        phone: null,
        salename: null,
        salesmanId: null,
        status: null
      },
      statusList: [{
        value: 0,
        label: '非会员'
      }, {
        value: 1,
        label: '会员'
      },
      {
        value: 2,
        label: '过期会员'
      },
      {
        value: 3,
        label: '即将过期会员'
      }
      ],
      tableData: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      platformType: [],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      value2: [
        // this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        // this.$moment().format('YYYY-MM-DD')
      ],
      storeListByCode: [],
      homePageData: {}, // 首页装修数据
      homePageParams: {
        bannerVos: [],
        discountList: [],
        packageClassificationVos: [],
        packageVos: [],
        storeId: '',
        videoUrl: []
      },
      // waterfallConfig: {
      //   width: 150, // 卡片宽度
      //   gutter: 8, // 卡片间距
      //   breakpoints: {
      //     1200: { rowPerView: 3 },
      //     800: { rowPerView: 2 }
      //   },
      //   backgroundColor: '#ffffff'
      // },
      selectedDiscountVos: null,
      selectedShareVos: null,
      classificationData: [],
      map: null, // 地图实例
      marker: null, // 地图标记
      currentPreviewRow: null // 当前预览的行数据
    }
  },
  computed: {
    // 处理瀑布流数据格式，按sort字段排序
    waterfallDataComputed () {
      return this.homePageParams.packageVos
        .map((item, index) => ({
          id: item.id || index,
          src: item.bannerUrl,
          packageName: item.packageName,
          packageId: item.packageId,
          sort: item.sort,
          loaded: false, // 添加加载状态
          error: false // 添加错误状态
        }))
        .sort((a, b) => (a.sort || 0) - (b.sort || 0)) // 按sort字段从小到大排序
    },
    videoDisplayData () {
      const sortedVideos = [...this.homePageParams.videoUrl].sort((a, b) => (a.sort || 0) - (b.sort || 0))

      if (sortedVideos.length === 0) {
        return []
      }

      const result = []
      const total = sortedVideos.length

      // 1个：单个占满
      if (total === 1) {
        result.push({ type: 'full', videos: [sortedVideos[0]] })
        return result
      }

      // 2个：一行2个
      if (total === 2) {
        result.push({ type: 'row', videos: [sortedVideos[0], sortedVideos[1]] })
        return result
      }

      // 3个：第一行2个，第二行1个（占满）
      if (total === 3) {
        result.push({ type: 'row', videos: [sortedVideos[0], sortedVideos[1]] })
        result.push({ type: 'full', videos: [sortedVideos[2]] })
        return result
      }

      // 偶数个：全部一行2个
      if (total % 2 === 0) {
        for (let i = 0; i < total; i += 2) {
          result.push({ type: 'row', videos: [sortedVideos[i], sortedVideos[i + 1]] })
        }
        return result
      }

      // 奇数个且超过4个：前三个2+1样式，后面全部一行2个
      // 前三个：2+1
      result.push({ type: 'row', videos: [sortedVideos[0], sortedVideos[1]] })
      result.push({ type: 'full', videos: [sortedVideos[2]] })

      // 后面的：全部一行2个
      for (let i = 3; i < total; i += 2) {
        result.push({ type: 'row', videos: [sortedVideos[i], sortedVideos[i + 1]] })
      }
      return result
    }
  },
  watch: {
    $route: {
      handler: function (newRoute, oldRoute) {
        console.log('当前路由：', newRoute)
        console.log('之前的路由：', oldRoute)
        if (newRoute.path == '/piya/shop') {
          this.formInline.systemCode = 'PIYA'
        } else {
          this.formInline.systemCode = ''
        }
        if (oldRoute && (oldRoute.path == '/piya/shop' || oldRoute.path == '/videoSeason/shop')) {
          this.searchPlateform(this.queryInfo)
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    },
    value2: {
      handler (val, oldVal) {
        console.log('val', val)
        if (val.length > 0) {
          this.formInline.startTime = val[0] + ' 00:00:00' || ''
          this.formInline.expireTime = val[1] + ' 23:59:59' || ''
        } else {
          this.formInline.startTime = ''
          this.formInline.expireTime = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      if (this.formInline.startTime && this.formInline.expireTime) {
        this.value2 = [this.formInline.startTime, this.formInline.expireTime]
      }
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    if (this.$route.query.auditStatus === 'PENDING') {
      this.formInline.auditStatus = 'PENDING'
    }
    this.getPlatformType()
    this.searchPlateform(this.queryInfo)
  },
  // 离开列表页销毁标识
  destroyed () {
    // 销毁
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    async updateProductCenterData (row) {
      let res = await updateProductCenter({ storeId: row.storeId, productCenter: row.productCenter })
      if (res.data.success) {
        this.searchPlateform(this.queryInfo)
      }
    },
    closePreviewHome () {
      this.homePageData = {} // 首页装修数据
      this.homePageParams = {
        bannerVos: [],
        discountList: [],
        packageClassificationVos: [],
        packageVos: [],
        storeId: '',
        videoUrl: []
      }
      this.selectedDiscountVos = null
      this.selectedShareVos = null
      this.classificationData = []
      this.currentPreviewRow = null
      this.previewHomeVisible = false
      // 销毁地图实例
      if (this.map) {
        this.map.destroy()
        this.map = null
        this.marker = null
      }
    },
    // 去除文件扩展名的辅助函数
    removeFileExtension (filename) {
      if (!filename) return ''
      const lastDotIndex = filename.lastIndexOf('.')
      // 如果没有点，直接返回原文件名
      if (lastDotIndex === -1) return filename

      // 常见的视频文件扩展名列表
      const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v', '3gp', 'ogv']

      // 获取最后一个点后面的部分（扩展名）
      const extension = filename.substring(lastDotIndex + 1).toLowerCase()

      // 只有当最后一个点后面是常见的视频扩展名时，才去除扩展名
      if (videoExtensions.includes(extension)) {
        return filename.substring(0, lastDotIndex)
      }

      // 如果不是已知的扩展名，返回原文件名（可能是文件名中包含点，如 "2.Today is sunny"）
      return filename
    },
    previewHome (row) {
      this.currentPreviewRow = row // 保存当前预览的行数据
      getHomeDecoration(row.storeId).then(res => {
        this.homePageData = res.data.data
        this.homePageParams.bannerVos = 'bannerList' in this.homePageData ? this.homePageData.bannerList : []
        // this.homePageParams.videoUrl = 'videoUrl' in this.homePageData ? this.homePageData.videoUrl : null
        // 兼容旧数据：如果有 videoUrl，转换为 videoVos 数组
        if ('videoUrl' in this.homePageData && this.homePageData.videoUrl) {
          this.homePageParams.videoUrl = [
            {
              id: Date.now(),
              name: this.removeFileExtension(this.homePageData.name),
              videoUrl: this.homePageData.videoUrl,
              sort: 1
            }
          ]
        } else if ('mediaList' in this.homePageData && this.homePageData.mediaList) {
          // 处理 mediaList 格式：将 url 转换为 videoUrl，保留 sort
          this.homePageParams.videoUrl = this.homePageData.mediaList.map((item, index) => ({
            id: item.id || Date.now() + index,
            name: this.removeFileExtension(item.name),
            videoUrl: item.url,
            sort: item.sort || index + 1,
            mimetype: item.mimetype
          }))
        } else {
          this.homePageParams.videoUrl = []
        }
        this.homePageParams.packageVos =
          'packageList' in this.homePageData ? this.homePageData.packageList : []
        if ('discountList' in this.homePageData) {
          this.homePageParams.discountList = this.homePageData.discountList
          this.homePageParams.discountList.forEach((item) => {
            if (item.type === 1) {
              this.selectedDiscountVos = { ...item, activityName: item.associationName }
            } else {
              this.selectedShareVos = { ...item, name: item.associationName }
            }
          })
        }
        getClassificationList(row.storeId).then(res => {
          this.classificationData = res.data.data
        })
        this.previewHomeVisible = true
        // 等待 dialog 渲染完成后初始化地图
        this.$nextTick(() => {
          this.initMap(row)
        })
      }).catch(() => {
        // 错误处理
      })
    },
    isDiscountTimeAfter (discount) {
      const startTime = (discount && discount.coupon && discount.coupon.receiveStartTime) || (discount && discount.receiveStartTime)
      return (
        startTime &&
        moment().isAfter(moment(startTime)) &&
        moment().isBefore(moment((discount && discount.coupon && discount.coupon.receiveEndTime) || (discount && discount.receiveEndTime)))
      )
    },
    isShareTimeAfter (share) {
      const startTime = (share && share.shareActivity && share.shareActivity.coupon && share.shareActivity.coupon.receiveStartTime) || (share && share.startTime)
      return (
        startTime &&
        moment().isAfter(moment(startTime)) &&
        moment().isBefore(moment((share && share.shareActivity && share.shareActivity.coupon && share.shareActivity.coupon.receiveEndTime) || (share && share.endTime)))
      )
    },
    chack (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/shop/detail', query: { id: row.id } })
    },
    setting (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/shop/set', query: { id: row.id, storeId: row.storeId, systemCode: this.formInline.systemCode } })
    },
    async generateQRCode (val) {
      this.qrCodeLoading = true
      let userId = val.userId
      let storeId = val.storeId // 平台id
      const qrcodeAddSceneRes = await qrcodeAddScene(`CEND=${userId}=${storeId}`)
      const getDiyQRCodeRes = await getQRCode({
        appid: val.wxConfigList[0].appId,
        page: 'pages/login/index',
        scene: qrcodeAddSceneRes.data.data.id,
        check_path: false,
        env_version: process.env.NODE_ENV === 'production' ? 'release' : 'trial',
        storeId: storeId
      })
      this.qrBase64 = 'data:image/png;base64,' + getDiyQRCodeRes.data.data.bytes
      this.qrCodeLoading = false
      this.previewVisible = true
    },
    examine (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/checkplatform', query: { id: row.id, code: row.code } })
    },
    edit (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/editplatform', query: { id: row.id, auditStatus: row.auditStatus } })
    },
    filterMethod (val) {
      if (val.trim()) {
        getMembershipListForQuery({ code: val }).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    // 设置cookie
    setCookie () {
      // 获取当前路由，将当前页面的路由作为name存入cookie中
      let name = this.$route.path
      // 需要存入的参数
      document.cookie = name + '=' + this.$qs.stringify(this.formInline)
    },
    // 从cookie中获取之前存入的参数
    // data为指定页面的路由，当从指定页面返回到当前页面时才到cookie中获取上一次存入的参数 。
    getCookie (data) {
      if (data === '/checkplatform' || data === '/editplatform') {
        let name = this.$route.path
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        let arr = document.cookie.match(reg)
        // if (arr === document.cookie.match(reg)) {
        this.formInline = this.$qs.parse(arr[2])
        if (this.formInline.platformTypeid !== '') {
          this.formInline.platformTypeid = parseInt(this.formInline.platformTypeid)
        }
        // }
      }
    },
    getPlatformType () {
      storeTypeGetStoreTypeList().then((res) => {
        this.platformType = res.data.data
      })
    },
    searchPlateform (val) {
      // 设置参数
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      }
      getMembershipList({ pageNum: val.pageNum, pageSize: val.pageSize, storeVo: this.formInline }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.searchPlateform(this.queryInfo)
    },
    deleteEmptyProperty (object) {
      for (var i in object) {
        var value = object[i]
        if (typeof value === 'object') {
          if (Array.isArray(value)) {
            if (value.length === 0) {
              delete object[i]
              continue
            }
          }
          this.deleteEmptyProperty(value)
          if (this.isEmpty(value)) {
            delete object[i]
          }
        } else {
          if (value === '' || value === null || value === undefined) {
            delete object[i]
          } else {
          }
        }
      }
      return object
    },
    getPlatformStatus (scope, e) {
      let status = e.target.innerText
      if (status === '审核') {
        this.$router.push({
          path: '/checkplatform',
          query: {
            id: scope.id,
            code: scope.code
          }
        })
      }
      if (status === '查看/编辑') {
        this.$router.push({
          path: '/editplatform',
          query: {
            id: scope.id
          }
        })
      }
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let _this = this
      storeExport(_this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '店铺信息表' + '.xls'
          if (this.value2.length) {
            _fileName = '店铺信息表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          }
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    applyplatform (type, val) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({
        path: '/shop/vipAdd',
        query: { selected: '2', systemCode: this.formInline.systemCode ? this.formInline.systemCode : 'VIDEO', applyType: type, renewId: val ? val.id : null }
      })
    },
    sizeChange (pageSize) {
      this.queryInfo.pageSize = pageSize
      this.getPageData()
    },
    pageIndexChange (pageIndex) {
      this.queryInfo.pageNum = pageIndex
      this.getPageData()
    },
    getPageData () {
      this.queryInfo.total = Math.ceil(this.queryInfo.total / this.queryInfo.pageSize)
      this.tableData = this.tableData.slice(this.queryInfo.pageSize * (this.queryInfo.pageNum - 1), this.queryInfo.pageSize * this.queryInfo.pageNum)
    },
    // 处理图片加载错误
    handleImageError (event) {
      // 可以设置默认图片
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDE1MCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxNTAiIGhlaWdodD0iMTIwIiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9Ijc1IiB5PSI2MCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+5Zu+54mH5Y2g5L2N5L2N5Y2gPC90ZXh0Pgo8L3N2Zz4K'
      // 设置错误状态
      const img = event.target
      const item = this.waterfallDataComputed.find(item => item.src === img.src)
      if (item) {
        item.error = true
      }
    },
    onImageLoad (event) {
      // 图片加载成功后，设置加载状态
      const img = event.target
      const item = this.waterfallDataComputed.find(item => item.src === img.src)
      if (item) {
        item.loaded = true

        // 动态计算图片的实际高度并设置grid-row span
        const container = img.closest('.waterfall-item')
        if (container) {
          const imgHeight = img.naturalHeight
          const imgWidth = img.naturalWidth
          const containerWidth = container.offsetWidth

          // 计算图片在容器中的实际显示高度
          const displayHeight = (imgHeight / imgWidth) * containerWidth

          // 将高度转换为grid-row span值（每行10px）
          const spanValue = Math.ceil(displayHeight / 10)

          // 设置grid-row span
          container.style.gridRow = `span ${spanValue}`
        }
      }
    },
    // 初始化地图
    async initMap (row) {
      // 检查高德地图是否加载
      // eslint-disable-next-line no-undef
      if (typeof AMap === 'undefined') {
        return
      }

      // 检查是否有地址信息
      if (!row.address || !row.address.provinceCode) {
        console.warn('地址信息不完整')
        return
      }

      try {
        // 获取省市区名称和编码
        const provinceName = row.address.province
        const cityName = row.address.city
        const countyName = row.address.county
        const cityId = row.address.cityId // 城市编码
        const provinceCode = row.address.provinceCode // 省编码

        // 构建地址字符串，过滤掉空值
        const addressParts = [provinceName, cityName, countyName].filter(Boolean)
        const addressStr = addressParts.join('')

        if (!addressStr) {
          return
        }

        // 初始化地图
        const mapContainer = document.getElementById('map')
        if (!mapContainer) {
          return
        }

        // 先使用默认中心点创建地图
        // eslint-disable-next-line no-undef
        this.map = new AMap.Map('map', {
          zoom: 13,
          center: [116.397428, 39.90923] // 默认北京坐标
        })

        // 使用高德地图 Web 服务 API 进行地理编码
        this.geocodeWithWebAPI(addressStr, cityId, provinceName, cityName, countyName)
      } catch (error) {
        // 错误处理
      }
    },
    // 使用高德地图 Web 服务 API 进行地理编码
    async geocodeWithWebAPI (addressStr, cityId, provinceName, cityName, countyName) {
      // 从 index.html 中获取 API Key，或者使用固定的 Key
      // 注意：实际项目中应该将 API Key 存储在配置文件中
      const apiKey = 'ca879c5b56fb7419694065fb46934680' // 从 index.html 中获取的 Key

      // 构建请求 URL
      let url = `https://restapi.amap.com/v3/geocode/geo?address=${encodeURIComponent(addressStr)}&key=${apiKey}`

      // 如果提供了城市编码，添加到请求参数中
      if (cityId) {
        url += `&city=${encodeURIComponent(String(cityId))}`
      }

      try {
        const response = await fetch(url)
        const data = await response.json()

        // 检查响应状态
        if (data.status === '1' && data.geocodes && data.geocodes.length > 0) {
          // 解析经纬度（格式为 "经度,纬度"）
          const locationStr = data.geocodes[0].location
          const [lng, lat] = locationStr.split(',').map(Number)

          // 设置地图中心点
          this.map.setCenter([lng, lat])
          this.map.setZoom(13)

          // 添加标记
          if (this.marker) {
            this.marker.setPosition([lng, lat])
          } else {
            // eslint-disable-next-line no-undef
            this.marker = new AMap.Marker({
              position: [lng, lat],
              title: addressStr,
              map: this.map
            })
          }

          // 添加信息窗口
          // eslint-disable-next-line no-undef
          const infoWindow = new AMap.InfoWindow({
            content: `<div style="padding: 10px;"><strong>${addressStr}</strong></div>`,
            // eslint-disable-next-line no-undef
            offset: new AMap.Pixel(0, -30)
          })
          this.marker.on('click', () => {
            infoWindow.open(this.map, this.marker.getPosition())
          })
        } else {
          // 如果失败，尝试使用备用方法
          this.fallbackGeocode(provinceName, cityName, countyName)
        }
      } catch (error) {
        // 如果出错，尝试使用备用方法
        this.fallbackGeocode(provinceName, cityName, countyName)
      }
    },
    // 备用地理编码方法（使用更简单的地址）
    async fallbackGeocode (provinceName, cityName, countyName) {
      if (!this.map) {
        console.warn('地图未初始化，无法使用备用地理编码')
        return
      }

      // 构建更简单的地址字符串（只使用省市，不使用区县）
      const addressParts = [provinceName, cityName].filter(Boolean)
      const addressStr = addressParts.join('')

      if (!addressStr) {
        console.warn('地址信息为空，无法进行地理编码')
        return
      }

      // 使用 Web 服务 API 再次尝试
      const apiKey = 'ca879c5b56fb7419694065fb46934680'
      const url = `https://restapi.amap.com/v3/geocode/geo?address=${encodeURIComponent(addressStr)}&key=${apiKey}`

      try {
        const response = await fetch(url)
        const data = await response.json()

        if (data.status === '1' && data.geocodes && data.geocodes.length > 0) {
          const locationStr = data.geocodes[0].location
          const [lng, lat] = locationStr.split(',').map(Number)

          this.map.setCenter([lng, lat])
          this.map.setZoom(12)

          if (this.marker) {
            this.marker.setPosition([lng, lat])
          } else {
            // eslint-disable-next-line no-undef
            this.marker = new AMap.Marker({
              position: [lng, lat],
              title: addressStr,
              map: this.map
            })
          }
        }
      } catch (error) {
        // 错误处理
      }
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}

.qr-preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-preview-img {
  max-width: 100%;
  max-height: 400px;
}

/* 覆盖指示器样式 */
.custom-carousel @{deep} .el-carousel__indicator {
  padding: 8px 4px;
  /* 调整圆点间距 */
}

.custom-carousel @{deep} .el-carousel__button {
  width: 5px;
  /* 圆点宽度 */
  height: 5px;
  /* 圆点高度 */
  border-radius: 50%;
  /* 圆形 */
  background-color: rgba(255, 255, 255, 0.71);
  /* 默认颜色（半透明白） */
}

.custom-carousel @{deep} .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #fff;
  /* 激活状态颜色（纯白） */
}

.main-container-center-from {
  display: flex;
  height: 125px;
  background-color: #212121;
  flex-wrap: nowrap;
  overflow-x: auto;
  background-color: white;
  padding: 10px 10px 0 10px;
  margin: 8px 0 0 0;
  overflow-y: hidden;
}

.perfect-waterfall {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  // grid-auto-rows: 10px;
  grid-auto-flow: dense;
  gap: 10px;
  padding: 10px;
  // background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin: 10px 0;
}

.waterfall-item {
  width: 100%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  grid-row: span 15;
  /* 默认高度，图片加载后会动态调整 */

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(-4px) scale(1.01);
  }
}

.image-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.waterfall-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.waterfall-item:hover .waterfall-image {
  transform: scale(1.1);
}

.loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #409eff;
  font-size: 24px;
  z-index: 2;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.error-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 8px;
  text-align: center;

  i {
    font-size: 24px;
    margin-bottom: 5px;
    color: #c0c4cc;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .perfect-waterfall {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .perfect-waterfall {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 12px;
  }
}

#map {
  border-radius: 8px;
  overflow: hidden;
}

/* 视频全屏播放样式 - 确保竖版视频完整显示 */
.video-element:fullscreen {
  object-fit: contain !important;
  width: 100vw !important;
  height: 100vh !important;
  border-radius: 0 !important;
}

/* 兼容不同浏览器的全屏伪类 */
.video-element:-webkit-full-screen {
  object-fit: contain !important;
  width: 100vw !important;
  height: 100vh !important;
  border-radius: 0 !important;
}

.video-element:-moz-full-screen {
  object-fit: contain !important;
  width: 100vw !important;
  height: 100vh !important;
  border-radius: 0 !important;
}

.video-element:-ms-fullscreen {
  object-fit: contain !important;
  width: 100vw !important;
  height: 100vh !important;
  border-radius: 0 !important;
}
</style>
